import {
  Button,
  HStack,
  Link,
  Text,
  VStack,
} from '@ayble-health/dashboard-components';
import { useDashboardPageState } from '../../../hooks/useDashboardPageState';
import PharmacySection from 'components/UserDashboard/overview/PharmacySection';
import {
  PrescriptionMedicationResourceType,
  PrescriptionMedicationStatus,
} from 'api/types';
import { ExternalLinkIcon, PlusIcon } from 'lucide-react';
import { useState } from 'react';
import AddMedicationForm from 'components/UserDashboard/overview/AddMedicationForm';
import { useUserMedicationsPrescriptions } from 'api/healthCoach/useUserMedicationsPrescriptions';

const { REACT_APP_HEALTHIE_URL } = process.env;

const ACTIVE_STATUSES = [
  PrescriptionMedicationStatus.Active,
  PrescriptionMedicationStatus.Future,
];

export const PharmacyPage = () => {
  const [isAddingMedication, setIsAddingMedication] = useState(false);
  const {
    state: { user },
  } = useDashboardPageState();
  const { data: prescriptionsMedications } = useUserMedicationsPrescriptions({
    userId: user?.id,
  });

  const activeMeds = prescriptionsMedications?.filter(
    ({ status, resource_type }) =>
      !!status &&
      ACTIVE_STATUSES.includes(status) &&
      resource_type === PrescriptionMedicationResourceType.Medication
  );

  const activeRx = prescriptionsMedications?.filter(
    ({ status, resource_type }) =>
      !!status &&
      ACTIVE_STATUSES.includes(status) &&
      resource_type === PrescriptionMedicationResourceType.Prescription
  );

  const inactive = prescriptionsMedications?.filter(
    ({ status }) => status === PrescriptionMedicationStatus.Inactive
  );

  return (
    <VStack p={6} gap={2}>
      <Link
        target="healthie"
        href={`${REACT_APP_HEALTHIE_URL}/users/${user?.healthie_id}`}
        color={'bluegrey'}
        alignSelf={'flex-start'}
      >
        Order E-prescription
        <ExternalLinkIcon size={16} />
      </Link>
      <HStack w={'100%'} justifyContent={'space-between'} alignItems={'center'}>
        <Text color={'evergreen'} fontSize={'15px'} fontWeight={'semibold'}>
          Pharmacy
        </Text>

        <Button
          size={'xs'}
          onClick={() => setIsAddingMedication(true)}
          disabled={isAddingMedication}
          variant={'outline'}
          borderRadius={'sm'}
          fontSize={'12px'}
          h={7}
        >
          <PlusIcon size={12} /> Add Medication
        </Button>
      </HStack>

      <Text
        color={'bluegrey'}
        fontWeight={400}
        fontFamily={'body'}
        fontSize={'xs'}
      >
        {activeRx?.length ?? 0}{' '}
        {activeRx?.length === 1 ? 'e-prescription' : 'e-prescriptions'} ·{' '}
        {activeMeds?.length ?? 0}{' '}
        {activeMeds?.length === 1 ? 'medication' : 'medications'}
      </Text>

      {isAddingMedication && (
        <AddMedicationForm onClose={() => setIsAddingMedication(false)} />
      )}

      <PharmacySection title={'E-Prescriptions'} items={activeRx} />

      <PharmacySection title={'Medications'} items={activeMeds} />

      {inactive && (
        <PharmacySection collapsible title={'Not Active'} items={inactive} />
      )}
    </VStack>
  );
};

export default PharmacyPage;
